var _sodipodiNamedview, _defs, _metadata, _title;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    id: "svg2",
    height: 25,
    width: 25,
    sodipodiDocname: "close_icon_grey.svg",
    "inkscapeExport-filename": "D:\\\\\\\\\\u0417\\u0430\\u0433\\u0440\\u0443\\u0437\\u043A\\u0438\\\\\\\\close_icon_black2.svg.png",
    "inkscapeExport-xdpi": 72.959999,
    "inkscapeExport-ydpi": 72.959999,
    inkscapeVersion: "0.92.3 (2405546, 2018-03-11)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    objecttolerance: 10,
    gridtolerance: 10,
    guidetolerance: 10,
    inkscapePageopacity: 0,
    inkscapePageshadow: 2,
    "inkscapeWindow-width": 1366,
    "inkscapeWindow-height": 706,
    id: "namedview3731",
    showgrid: "false",
    inkscapeZoom: 15.245222,
    inkscapeCx: 5.6822049,
    inkscapeCy: 12.495936,
    "inkscapeWindow-x": -8,
    "inkscapeWindow-y": -8,
    "inkscapeWindow-maximized": 1,
    "inkscapeCurrent-layer": "imagebot_2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs13"
  })), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "imagebot_6"
  }, "image/svg+xml", /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }), /*#__PURE__*/React.createElement("dcTitle", null))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.9661017,3.5677966)",
    id: "imagebot_2",
    label: "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    "inkscapeConnector-curvature": 0,
    strokeMiterlimit: 4,
    d: "M -2.5783352e-4,-0.00146808 17.435473,18.212367",
    id: "imagebot_5",
    style: {
      opacity: 1,
      fill: "#5f6368",
      stroke: "#5f6368",
      strokeWidth: 3.23161912,
      strokeMiterlimit: 4,
      fillOpacity: 1,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    "inkscapeConnector-curvature": 0,
    strokeMiterlimit: 4,
    d: "M -2.5783352e-4,18.212367 17.435473,-0.00146808",
    id: "imagebot_4",
    style: {
      opacity: 1,
      fill: "#5f6368",
      stroke: "#5f6368",
      strokeWidth: 3.23161912,
      strokeMiterlimit: 4,
      fillOpacity: 1,
      strokeOpacity: 1
    }
  }), _title || (_title = /*#__PURE__*/React.createElement("title", {
    id: "title9"
  }, "Layer 1"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXClose);
export default __webpack_public_path__ + "static/media/x-close.5cd4c7ba0e799f0ca67dd6cfaa1c427e.svg";
export { ForwardRef as ReactComponent };